


























import Vue from "vue";

export type HealthTab = "day" | "sleep" | "activities";

export default Vue.extend({
  name: "HealthTabs",
  props: { activeTab: { type: String, required: true } },
  data: () => ({
    tabs: [
      { key: "day" as HealthTab, label: "Meu dia", icon: "heart" },
      { key: "activities" as HealthTab, label: "Atividades", icon: "heartbeat" },
      { key: "sleep" as HealthTab, label: "Sono", icon: "moon" }
    ]
  })
});
